import { configACADEMONDO } from '../src/aca-config-ACADEMONDO';

export const acaConfig = configACADEMONDO;
